import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import styled from "styled-components";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import "../../microservice/container/sidebar.css";
import "../../Style/defaultstyle.css";
import "../../Style/defaultstyle.scss";
import CommonTable from "../../container/Table/Components/CommonTable";
import CardTable from "../../microservice/components/CardTable";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import config from "../../microservice/components/config-en";
import Sidebar from "../../container/Sidebar/Sidebar";

// add
import { Grid } from "@mui/material";
import CardBox from "../../container/Box/Components/CardBox";
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BanneServerApplication from "../../container/Banner/banner-serverApplication";
import DividerComponent from "../../container/Divider/divider";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-en";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import FooterEn from "../../detailpageVN/Page/component/footeren";
import HeaderEn from "../../detailpageVN/Page/component/headeren";
import SidebarEn from "../../container/Sidebar/Sidebar-en";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

// Titlecloudcompute
function IaamENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Identity And Access Management - Serverless Application - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Identity and Access Management")} */}

                        {CardTable("<p class='typo-21 typo-medium typo-black'>Notion</p>", config.tb2_header, config.tb2_content)}
                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}>
                                <Typography className="sub-title normal" sx={CardTitle}>
                                    <p class="typo-21 typo-medium typo-black">OIDC/Oauth</p>
                                </Typography>
                            </Box>
                            <BoxText>
                                <p class="typo-14">• OIDC (OpenID Connect): Used for authentication; provides an ID Token containing the user's identity information.</p>
                                <p class="typo-14">• OAuth : </p>
                                <p class="typo-14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delegated authorization (Permission Delegation)</p>
                                <p class="typo-14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Procedure for verifying access to resource servers.</p>
                                <p class="typo-14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Obtaining an Access Token to retrieve resources from the resource server</p>
                            </BoxText>
                            <Grid container spacing={1}>
                                <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/msa3-1.png"></ImageWrap>

                                <Grid item xs={12} sm={12}>
                                    {CardBox(
                                        "",
                                        `<p class='typo-14'>Example </p>
                                    <p class='typo-14'>User (1) ~ (9) logging into your application using their's Facebook account.</p>
                                    <p class='typo-14'>Allow (user) to write to newsfeed (resource) with (Facebook) permission in (our application) (A) \~ (D).</p></br>
                                    <p class='typo-14'>Delegation and Method</p>
                                    <p class='typo-14'>1. The user provides their Facebook ID/password directly to the company's application (not recommended for security reasons).</p>
                                    <p class='typo-14'>2. Using OAuth (the safer approach): The application never learns the user's Facebook credentials, ensuring security</p>`,
                                    )}
                                </Grid>
                            </Grid>
                            <BoxContent>
                                <BoxTitleIaam className="sub-title">
                                    <p class="typo-21 typo-medium typo-black">Token Generation and Authorization</p>
                                </BoxTitleIaam>
                                <CommonTable header={config.tb3_header} content={config.tb3_content} />
                            </BoxContent>
                        </BoxContent>

                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}>
                                <Typography className="sub-title normal" sx={CardTitle}>
                                    <p class="typo-21 typo-medium typo-black">IAM Usage Guide</p>
                                </Typography>
                            </Box>

                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/msa3-2.png"></ImageWrap>
                            <SmallBox>
                                <BoxDetail>
                                    <p class="typo-14">A Role is a collection of permissions that allow actions such as create, modify, delete, share, and read (list/view).</p>
                                </BoxDetail>
                            </SmallBox>
                            <SmallBox>
                                <BoxDetail>
                                    <p class="typo-14">- Default generated Role Name — e.g., Role Name (Permission Action)</p>
                                    <p class="typo-14">- Owner(all)</p>
                                    <p class="typo-14">- Admin(all except delete)</p>
                                    <p class="typo-14">- Editor(create/ delete/ update/ get/ list)</p>
                                    <p class="typo-14">- Viewer(get/list)</p>
                                    <p class="typo-14">- OnlyListingUser(list)</p>
                                </BoxDetail>
                            </SmallBox>
                            <SmallBox>
                                <BoxDetail>
                                    <p class="typo-14">Example</p>
                                    <p class="typo-14">Resource - File A</p>
                                    <p class="typo-14">The creator (User A) has All permissions</p>
                                    <p class="typo-14">User B is granted (Create, Delete, Update, Read) permissions</p>
                                    <p class="typo-14">Group C is granted only the listing view permission</p>
                                </BoxDetail>
                                <br></br>
                                <BoxText>
                                    <p class="typo-14">• Access Control Setup</p>
                                </BoxText>
                                <BoxDetail>
                                    <p class="typo-14">In the access control settings of File A:</p>
                                    <p class="typo-14">User A, upon creating the file, is automatically assigned the tag “A’s Files”, with all permissions granted</p>
                                    <p class="typo-14">Select User B and assign the Editor role.</p>
                                    <p class="typo-14">Select Group C and assign the OnlyListingUser role.</p>
                                    <p class="typo-14">Tag = Service / Resource Type / Owner</p>
                                </BoxDetail>
                            </SmallBox>

                            {/* {Imagecloudcompute("https://hanbiro.com/docs/cloud/images/c.png")} */}

                            {/*}
                            <BoxDetail >
                                사용자와 자원을 분리해 중간에 역활을 추가<br/>
                                사용자는 자주 바뀌지만 역활은 자주바뀌지 않음<br/>
                                서비스(Object)에 접속하는 Client(Subject)들은 미리 정의한<br/>
                                역활명으로 분류함 역활에 따라 자원(Object)의 Actions 권한을 할당<br/>
                                권한을 줄때 Role 단위로 줌<br/>
                                사용자는 할당된 역활에 기반하여 객체에 접근<br/>
                                역활은 직무에 따라서 정의<br/>
                                한유저는 여러 역활에 배정가능<br/>
                                여러유저는 한 역활에 배정가능
                            </BoxDetail>
                            {*/}
                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            <FooterEn />
        </Sysfont>
    );
}

const BoxSubText = styled.div`
    margin-left: 3%;
`;

const BoxTitleIaam = styled.div`
    text-align: center;
    font-weight: bold;
    margin: 15px;
`;

const CardTitle = {
    textAlign: "left",
    fontWeight: "bold",
    fontFamily: "맑은고딕, Dotum, 돋움, sans-serif !important;",
};

const TitleWrap = {
    height: "40px",
};

// const Box = styled.div`
//   @media only screen and (max-width: 767px){
//     font-size: 80%;
//   }
// `

const ImageWrap = styled.img`
    width: 100%;
    object-fit: fill;
`;

const BoxContent = styled.div`
    ${
        "" /* box-shadow: 0 0.375rem 1.5rem rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    margin-top: 20px; */
    }
    text-align: left;
`;

const SmallBox = styled.div`
    ${
        "" /* border: 1px solid #E7EAF3;
    border-radius: 8px; */
    }
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: left;
`;

const BoxDetail = styled.div`
    margin: 10px 5px;
    line-height: 2em;
`;

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`;

export default IaamENG;
